import React from 'react';
import { useEffect } from 'react';
import { Link,useLocation } from 'react-router-dom';
import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin, 
  FaYoutube,
  FaHome,
  FaUpload,
  FaSearch,
  FaBriefcase,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  const location = useLocation();
  useEffect(()=>{
    window.scrollTo(0,0);
  },[location]);
  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 text-black py-16 border-t">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Description */}
          <div className="flex flex-col items-center md:items-start">
            <a 
              href="https://www.ambujafoundation.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mb-4"
            >
              <img 
                src="/images/logo.jpg" 
                alt="Ambuja Foundation Logo" 
                className="h-16 hover:opacity-90 transition-opacity mt-8"
              />
            </a>
            <p className="text-center md:text-center font-semibold text-[#080366]">
              Ambuja Foundation
            </p>
            {/* <p className="text-gray-600 text-sm text-center md:text-left">
            
            </p>*/}
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h2 className="text-lg font-bold text-[#080366] mb-6">
              Quick Links
            </h2>
            <ul className="flex flex-col items-center md:items-start space-y-4">
              <li>
                <Link 
                  to="/" 
                  className="flex items-center text-gray-600 hover:text-[#ed6503] transition-colors group"
                >
                  <FaHome className="mr-3 group-hover:scale-110 transition-transform" />
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/upload-resume" 
                  className="flex items-center text-gray-600 hover:text-[#ed6503] transition-colors group"
                >
                  <FaUpload className="mr-3 group-hover:scale-110 transition-transform" />
                  Upload Resume
                </Link>
              </li>
              <li>
                <Link 
                  to="/candidate-management" 
                  className="flex items-center text-gray-600 hover:text-[#ed6503] transition-colors group"
                >
                  <FaSearch className="mr-3 group-hover:scale-110 transition-transform" />
                  Candidates
                </Link>
              </li>
              <li>
                <Link 
                  to="/vacancies" 
                  className="flex items-center text-gray-600 hover:text-[#ed6503] transition-colors group"
                >
                  <FaBriefcase className="mr-3 group-hover:scale-110 transition-transform" />
                  View Vacancies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="flex flex-col items-center md:items-start">
            <h2 className="text-lg font-bold text-[#080366] mb-6">
              Regional Office
            </h2>
            <ul className="flex flex-col items-center md:items-start space-y-4">
              <li className="flex items-center text-gray-600">
                <FaMapMarkerAlt className="mr-3 text-gray-600 hover:text-[#ed6503] transition-colors group mb-12" />
                <p className="text-sm">
                <h3>Ambuja Foundation, Rajasthan</h3>
                Dakshinpuri, Karolan Ka Barh,<br /> Shri Kishanpura, Jaipur,<br /> Rajasthan 303905
                </p>
              </li>
             
            </ul>
          </div>

          {/* Social Media and Newsletter */}
          <div className="flex flex-col items-center md:items-start">
            <h2 className="text-lg font-bold text-[#080366] mb-6">
              Stay Connected
            </h2>
            <div className="flex space-x-4 mb-8">
              <a 
                href="/" 
                rel="noopener noreferrer" 
                className="text-xl text-gray-600 hover:text-[#ed6503] transition-colors hover:scale-110 transform"
              >
                <FaFacebook />
              </a>
              <a 
                href="/" 
                rel="noopener noreferrer" 
                className="text-xl text-gray-600 hover:text-[#ed6503] transition-colors hover:scale-110 transform"
              >
                <FaXTwitter />
              </a>
              <a 
                href="/" 
                rel="noopener noreferrer" 
                className="text-xl text-gray-600 hover:text-[#ed6503] transition-colors hover:scale-110 transform"
              >
                <FaInstagram />
              </a>
              <a 
                href="/" 
                rel="noopener noreferrer" 
                className="text-xl text-gray-600 hover:text-[#ed6503] transition-colors hover:scale-110 transform"
              >
                <FaLinkedin />
              </a>
              <a 
                href="/" 
                rel="noopener noreferrer" 
                className="text-xl text-gray-600 hover:text-[#ed6503] transition-colors hover:scale-110 transform"
              >
                <FaYoutube />
              </a>
            </div>
      
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0">
           
   <p className="text-gray-600 text-sm">
  &copy; {new Date().getFullYear()} Ambuja Foundation. All rights reserved. | 
   Developed by Team Future Skill Jaipur
</p>



           
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;